import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB1G: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="g) výsledky stavebního průzkumu"
      subtitle="včetně vyhodnocení přítomnosti azbestu a jiných nebezpečných látek ve stavbě"
      sectionKey="b1g"
    >
      <>
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1g.hasBuildingSurvey"
            label="Stavební průzkum"
          />
        </div>
        {formik?.values.b1g?.hasBuildingSurvey && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1g.buildingSurveyResults"
              label="Výsledky stavebního průzkumu"
              component={RichTextInput}
              aiHint={
                'Výsledky stavebního průzkumu odstraňované stavby'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1g.hasAsbestos"
            label="Přítomnost azbestu"
          />
        </div>
        {formik?.values.b1g?.hasAsbestos && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1g.asbestosEvaluation"
              label="Vyhodnocení přítomnosti azbestu"
              component={RichTextInput}
              aiHint={
                'Vyhodnocení přítomnosti azbestu v odstraňované stavbě'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1g.hasHazardousSubstances"
            label="Přítomnost jiných nebezpečných látek"
          />
        </div>
        {formik?.values.b1g?.hasHazardousSubstances && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1g.hazardousSubstances"
              label="Vyhodnocení přítomnosti jiných nebezpečných látek"
              component={RichTextInput}
              aiHint={
                'Vyhodnocení přítomnosti jiných nebezpečných látek v odstraňované stavbě'
              }
            />
          </div>
        )}
      </>
    </FormSectionTwoColumns>
  )
}
